// extracted by mini-css-extract-plugin
export default {"control":"index_control__L0R6z","pageope":"index_pageope__Rq2LR","pagination":"index_pagination__2wQnr","previewBtn":"index_previewBtn__h7j4T","sperature":"index_sperature__86-jB"};